module.exports = __webpack_public_path__ + "img/connect-1.7e825f40.png";